module.exports = __webpack_public_path__ + "static/download-app-c3c4d2452c3bd6e9a1d4d6467c42833d.svg";